<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <!-- section header end -->
    <section class="header-section">
      <div class="header-primary">
        <div class="header container">
          <div class="primary-list active-class">
            <div class="logo active-logo">
              <router-link to="/"
                ><img src="../../assets/img/newlogo.png" />
                <div class="logo-texts">
                  <span>Wizz<span class="tech">Tech</span></span>
                </div></router-link
              >
              <!-- <router-link to="/"
                ><img src="../../assets/img/forgedrift.png" />
              </router-link> -->
              <!-- <div class="logo-text"><span>WizzTech</span></div> -->
            </div>
            <div class="header-spacer" aria-hidden="true"></div>
            <!-- <div>
              <form class="nigisi-search">
                <input
                  type="text"
                  :placeholder="$store.state.trans.search"
                  name="search2"
                />
                <button type="submit">
                  <img src="../../assets/img/Search-icon.png" />
                </button>
              </form>
            </div> -->
            <div class="navigation-list">
              <ul class="nav-list">
                <li>
                  <router-link
                    to="/services"
                    :class="{ 'nav-link-active': $route.path === '/services' }"
                    >{{ activeLang === "ja" ? ($store.state.trans.service || "Services") : "Services" }}</router-link
                  >
                </li>
                <li>
                  <router-link to="/coverage">Coverage</router-link>
                </li>
                <li>
                  <router-link to="/why-us">Why us</router-link>
                </li>
                <li>
                  <router-link
                    to="/about"
                    :class="{ 'nav-link-active': $route.path === '/about' }"
                    >{{ activeLang === "ja" ? ($store.state.trans.about || "About") : "About" }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/contact"
                    :class="{ 'nav-link-active': $route.path === '/contact' }"
                    >{{ activeLang === "ja" ? ($store.state.trans.contact || "Contact") : "Contact" }}</router-link
                  >
                </li>
                <li class="header-spacer" aria-hidden="true"></li>
                <li class="language-item">
                  <div class="dropdown-center">
                    <button class="lang-menu" type="button" :aria-expanded="dropMenu" aria-label="Choose language" v-on:click="toggleMenu2">
                      <svg class="language-globe" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/></svg>
                      <span data-no-localize>{{ activeLang === "ja" ? "日本語" : "English" }}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        class="bi bi-chevron-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                        />
                      </svg>
                    </button>
                    <ul class="dropdown-menu1" v-if="dropMenu">
                      <li :class="{ 'active-lang': activeLang === 'en' }">
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent.stop="handleLang('en')"
                          data-no-localize lang="en">English</a
                        >
                      </li>
                      <li :class="{ 'active-lang': activeLang === 'ja' }">
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent.stop="handleLang('ja')"
                          data-no-localize lang="ja">日本語</a
                        >
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="project-cta">
                  <router-link
                    to="/contact"
                    class="btn btn-purple"
                  >
                    Get a quote
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- section header end -->
    <!-- Mobile header start  -->
    <div class="mob-header">
      <div class="nav-list">
        <div class="logo">
          <!-- <router-link to="/"
                ><img src="../../assets/img/forgedrift.png" />
              </router-link> -->
          <router-link to="/">
            <img src="../../assets/img/newlogo.png" alt="img" />
            <div class="logo-texts">
              <span>Wizz<span class="tech">Tech</span></span>
            </div>
          </router-link>
        </div>
        <div class="mobile-header-menu">
          <button class="memu-icon" v-on:click="toggleMenu">
            <svg
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 fill-current"
              data-v-705463ae=""
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 12a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 6a1 1 0
              011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 18a1 1 0 011-1h18a1 1 0
              110 2H3a1 1 0 01-1-1z"
                data-v-705463ae=""
              ></path>
            </svg>
          </button>
          <div class="dropdown-center">
            <div class="lang-menu" v-on:click="toggleMenu2">
              <img src="../../assets/img/globe.png" alt="Lang" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                class="bi bi-chevron-down"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                />
              </svg>
            </div>
            <ul class="dropdown-menu1" v-if="dropMenu">
              <li :class="{ 'active-lang': activeLang === 'en' }">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent.stop="handleLang('en')"
                  data-no-localize lang="en">English</a
                >
              </li>
              <li :class="{ 'active-lang': activeLang === 'ja' }">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent.stop="handleLang('ja')"
                  data-no-localize lang="ja">日本語</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mob-menu" v-if="mobileMenu">
        <div class="dropdown-menu2">
          <button class="close-btn" type="button" aria-label="Close menu" v-on:click="toggleMenu">
            <svg
              data-v-705463ae=""
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 fill-current"
            >
              <path
                data-v-705463ae=""
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.707 5.293a1 1 0 010 1.414l-12 12a1 1 0
                01-1.414-1.414l12-12a1 1 0 011.414 0z"
              ></path>
              <path
                data-v-705463ae=""
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.293 5.293a1 1 0 011.414 0l12 12a1 1 0 01-1.414
                1.414l-12-12a1 1 0 010-1.414z"
              ></path>
            </svg>
          </button>
          <ul class="menu" v-on:click="toggleMenu">
            <li><router-link to="/services">{{ activeLang === "ja" ? ($store.state.trans.service || "Services") : "Services" }}</router-link></li>
            <li><router-link to="/coverage">Coverage</router-link></li>
            <li><router-link to="/why-us">Why us</router-link></li>
            <li><router-link to="/about">{{ activeLang === "ja" ? ($store.state.trans.about || "About") : "About" }}</router-link></li>
            <li><router-link to="/contact">{{ activeLang === "ja" ? ($store.state.trans.contact || "Contact") : "Contact" }}</router-link></li>
            <li><router-link to="/contact" class="quote-link">Get a quote</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable prettier/prettier -->
<script>
export default {
  name: "AppHeader",
  data() {
    return {
      mobileMenu: false,
      dropMenu: false,
      activeLang: "en",
      activeNav: "home",
    };
  },
  mounted() {
    const lang = localStorage.getItem("lang");
    this.activeLang = lang || "en";
    this.updateActiveNavFromHash();
    document.addEventListener("click", this.handleLanguageClickOutside);
    window.addEventListener("hashchange", this.updateActiveNavFromHash);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleLanguageClickOutside);
    window.removeEventListener("hashchange", this.updateActiveNavFromHash);
  },
  methods: {
    handleLang(lang) {
      // window?.resetLanguage("en");
      this.activeLang = lang;
      localStorage.setItem("lang", lang);
      this.$store.dispatch("setLanguage", lang);
      this.$store.dispatch("setTranslations", lang);
      window.dispatchEvent(new Event("languagechange"));
      this.dropMenu = false;
    },
    toggleMenu() {
      this.mobileMenu = !this.mobileMenu;
    },
    toggleMenu2() {
      this.dropMenu = !this.dropMenu;
    },
    handleLanguageClickOutside(event) {
      if (!event.target.closest(".dropdown-center")) {
        this.dropMenu = false;
      }
    },
    updateActiveNavFromHash() {
      const navByHash = {
        "#service": "service",
        "#product": "portfolio",
        "#about": "about",
      };

      this.activeNav = navByHash[window.location.hash] || "home";
    },
  },
};
</script>
<!-- eslint-disable prettier/prettier -->
<style scoped>
/* header start  */
.logo .router-link-exact-active {
  background-image: unset !important;
}
.dropdown-toggle {
  transition: transform 1s ease;
}
.header-section {
  background-color: #fff;
  position: relative;
  z-index: 1;
  /* position: fixed; */
  /* top: 0; */
  border: 0;
  border-bottom: 1px solid #E3E7EC;
}
.since-primary {
  background-color: #000000;
  text-align: center;
  padding: 10px;
}
.link-innner svg {
  margin-left: 5px;
}
.btn-purple {
  background: #117b76;
  color: #fff !important;
  border: 2px solid #117b76;
  border-radius: 12px;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 27px !important;
  text-decoration: none !important;
}
.btn-purple:hover {
  background: #0d6662;
  color: #fff !important;
  text-decoration: none !important;
}
.btn-purple:after {
  background-image: unset !important;
  color: #fff !important;
}
.dropdown-toggle::after {
  border: unset !important;
}
.since-primary h6 {
  margin: 0;
  font-size: 13px;
  color: #fff;
  word-spacing: 1.5px;
  letter-spacing: 1.5px;
}
.header-primary {
  /* box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); */
  padding: 0;
  background: #fff;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1320px;
  padding: 0 24px;
}
.header .primary-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.header .active-logo .router-link-exact-active {
  background-size: 100% 5px !important;
  border-radius: unset !important;
}
.header .logo a {
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 18px 0;
}
.header .logo img {
  height: 58px;
}
.header .logo a .logo-texts {
  font-size: 25px;
  font-weight: 600;
  padding-left: 10px;
  color: #0b1f3a;
}
.header .logo a .logo-texts .tech {
  /* font-size: 14px !important; */
  color: #117b76 !important;
}
.header .active-class .router-link-exact-active:not(.btn-purple) {
  background-image: none;
  transition: background-size 0.25s ease-in;
  text-decoration: none;
  color: #28283a !important;
}
.header .active-class .router-link-exact-active img {
  display: flex;
}
.navigation-list > ul > li > a:hover img {
  display: flex;
}
.navigation-list > ul {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding: 0;
}
.navigation-list > ul li {
  list-style-type: none;
  border-radius: 8px;
  top: 2px;
  padding: 0 20px;
}
.navigation-list .nav-list li:last-child {
  padding-right: 0;
}
.navigation-list .nav-list li:first-child {
  padding-left: 0;
}
.navigation-list .nav-list > li > a {
  text-decoration: none;
  position: relative;
  color: #6b7789;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-top: 5px; */
  padding: 37px 0;
  white-space: nowrap;
}
.navigation-list .nav-list > li:not(.project-cta) > a {
  width: max-content;
}
.navigation-list .nav-list .project-cta {
  margin-left: 45px;
  padding-right: 0;
}
.navigation-list .nav-list .project-cta > a {
  padding: 15px 27px;
}
.navigation-list .nav-list .project-cta > a:after {
  display: none;
}
.navigation-list .nav-list .language-item {
  margin-left: 85px;
  padding: 0;
}
.navigation-list .nav-list > li > .nav-link-active:after {
  width: 100%;
}
.navigation-list .nav-list > li > .nav-link-active {
  color: #117b76 !important;
}
.header .navigation-list .nav-list > li:not(.project-cta) > a.router-link-exact-active {
  color: #117b76 !important;
}
.header .navigation-list .nav-list > li:not(.project-cta) > a.router-link-exact-active::after {
  width: 100%;
}
.navigation-list > ul > li > a:hover {
  color: #117b76;
}
.navigation-list > ul > li:hover ul.dropdown-menu2 {
  display: block;
}
.navigation-list > ul > li > a img {
  width: 14px;
  display: none;
  position: absolute;
  top: -10px;
}
.navigation-list > ul > li > a:after {
  content: "";
  width: 0;
  height: 2px;
  display: block;
  position: relative;
  top: 5px;
  background-image: linear-gradient(90deg, #117b76, #117b76);
  background-repeat: no-repeat;
  transition: width 0.2s ease;
  -webkit-transition: width 0.2s ease;
}
.navigation-list > ul > li > a:hover:after {
  width: 100%;
}
.lets-talk {
  display: flex;
  align-items: center;
  border-bottom: unset !important;
}
.lets-talk .btn-talk {
  background-color: #117b76;
  border-radius: 14px;
  font-weight: 400;
  padding: 6px 40px !important;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
  border: unset;
  /* box-shadow: 1px 1px 3px 0 rgba(209, 8, 249, 0.158); */
}
.lets-talk .price-list ul {
  border-left: unset;
}
.lets-talk .btn-talk:hover {
  transition-duration: 0.5s;
  background-color: #0d6662;
}
.dropdown-head {
  display: block;
}
.hover-dropdown:hover .dropdown-head {
  display: block;
}
/* header end */
.mob-header {
  display: none;
}
form.nigisi-search {
  display: flex;
  margin: auto;
  max-width: 500px;
  min-width: 150px;
  border-bottom: 1px solid #bbb9b9;
}
form.nigisi-search input[type="text"] {
  font-size: 14px;
  border: unset;
  float: left;
  width: 100%;
  background: #fff;
  color: #bbb9b9 !important;
}
form.nigisi-search input[type="text"]::placeholder {
  color: #bbb9b9 !important;
}
form.nigisi-search input:focus,
form.nigisi-search input:active {
  outline: none;
}
form.nigisi-search button {
  float: left;
  width: 20%;
  padding: 5px 10px;
  background: transparent;
  color: white;
  border: unset;
  border-left: none;
  cursor: pointer;
}

form.nigisi-search button img {
  width: 16px;
}

form.nigisi-search::after {
  content: "";
  clear: both;
  display: table;
}
.dropdown-menu1 {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 218px;
  height: 118px;
  box-sizing: border-box;
  gap: 4px;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: var(--Core-Surface, hsla(0, 0%, 100%, 1));
  border: 1px solid var(--Neutral-Border, hsla(277, 18%, 86%, 1));
  border-radius: 12px;
  opacity: 1;
  box-shadow: none;
  overflow: hidden;
  left: -25px;
  top: 26px;
}
.dropdown-menu1 li {
  flex: 1;
  padding: 0 !important;
}
.dropdown-menu1 li .dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #000;
}
.dropdown-menu1 li.active-lang .dropdown-item {
  position: relative;
  height: 48px;
  padding: 12px 16px;
  gap: 16px;
  border-radius: 8px;
  background: #eef8f7;
  color: #28283a;
  font-size: 16px;
}
.dropdown-menu1 li.active-lang .dropdown-item::after {
  position: absolute;
  right: 36px;
  content: "✓";
  font-size: 16px;
  font-weight: 600;
}
.dropdown-menu1 li .dropdown-item:hover {
  color: #117b76;
}
.lang-menu {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #28283a;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
.lang-menu img {
  width: 20px;
  margin-right: 0;
}
/* Desktop layout shown in the reference header. */
</style>
